import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-empty-item',
  templateUrl: './empty-item.component.html',
  styleUrls: ['./empty-item.component.scss'],
  standalone: false
})
export class EmptyItemComponent {
  @Input() icon: string = '';
  @Input() title: string = '';
  @Input() description: string = '';

  @Input() detailEmpty: boolean = false;

  @Input() buttonText: string = '';
  @Output() clickButton: EventEmitter<void> = new EventEmitter<void>();
}
